<template>
    <div class="modal-body">
        <div class="">
            <label for="estadoSolicitud">Estado de la Solicitud:</label>
            <select v-model="estadoSolicitud" required class="form-select" name="estadoSolicitud" id="estadoSolicitud">
                <option value="Aprobado">Aprobado</option>
                <option value="Rechazado">Rechazado</option>
                <option value="Pendiente">Pendiente</option>
            </select>
        </div>

        <div v-if="this.readyArchivos" class="mt-2">
                      <!-- {{this.contadorArchivos}} -->

                        <div class="d-flex">
                          Fotografía del DNI 
                          <div v-if="this.contadorArchivos.dni > 0">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;"></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          Fachada del Negocio
                          <div v-if="this.contadorArchivos.fachada > 0">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;" ></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          Fachada de la Casa
                          <div v-if="this.contadorArchivos.fachadacasa > 0">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;"></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div>
                        <!-- <div class="d-flex">
                            {{this.autorizadoFirma}}
                          Validacion de asesor(FIRMA)
                          <div v-if="this.autorizadoFirma">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;"></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div> -->
                        
                      </div>
        <p class="mt-2 mb-0 text-muted">
            Nota: estos archivos son informativos y no son obligatorios para aprobar.
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="handleSubmit()">Guardar</button>
        <button type="button"  class="btn btn-secondary"  data-bs-dismiss="modal">Cerrar</button>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import Security from '../security'

export default {
    name: 'EstadoSolicitud',
    props: {
        idSolicitud: String,
        autorizadoFirma: Boolean,
    },
    data() {
        return {
            estadoSolicitud: "",
            contadorArchivos: {},
            readyArchivos: false,
        }
    },
    
    beforeMount() {
        this.getCountArchivos(this.idSolicitud)
    },
    // mounted() {
    // const modalEl = this.$refs.modal;
    //     if (modalEl) {
    //         modalEl.addEventListener('show.bs.modal', () => {
    //         this.getCountArchivos(this.idSolicitud);
    //         });
    //     }
    // },
    beforeUnmount() {
        const modalEl = this.$refs.modal;
        if (modalEl) {
            modalEl.removeEventListener('show.bs.modal', this.getCountArchivos);
        }
    },

    methods: {
        
        handleSubmit() {
            if (this.estadoSolicitud !== '') {

                const payload = {
                    id: parseInt(this.idSolicitud),
                    estado: this.estadoSolicitud,
                    idUsuario: Security.getUser()[0].user.id,
                    
                }

                console.log(payload)
                Swal.fire({
                    title: '¿Estás Seguro del cambio de estado de la solicitud?',
                    icon: 'success',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Confirmar!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        console.log('confirmado')

                        fetch(
                        process.env.VUE_APP_API_URL +
                        "/admin/solicitud/update-estado" ,
                        Security.requestOptions(payload)
                    )
                        .then((response) => response.json())
                        .then((data) => {
                        if (data.error) {
                            Swal.fire({
                                        // position: 'top-end',
                                        icon: "error",
                                        title: data.message,
                                        showConfirmButton: false,
                                        timer: 1500,
                            });
                        } else {
                           console.log(data.data);
                        }
                        });

                        location.reload()
                    }
                })
            }
        },
        getCountArchivos(id) {

            fetch(process.env.VUE_APP_API_URL + `/admin/solicitud/count-tipos-archivos/${id}`, Security.requestOptions({}))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        this.$emit('error', response.message);
                        console.error(response.message)


                    } else {
                        console.log('Contador Response:', response.data.data)
                        this.contadorArchivos = response.data.data
                        this.readyArchivos = true
                    }
                })
                .catch(error => {
                    this.$emit('error', error)
                })
        }
    }
}
</script>

<style scoped></style>
